import React, { useState } from 'react';
import { Modal } from '../../components/ui';
import { errMsg } from '../../utils/format';
import { useFetch } from '../../hooks/useFetch';
import api from '../../utils/api';

export default function AddRMAModal({ onClose, onSaved }) {
  const { data: products } = useFetch('/api/products');
  const [form, setForm] = useState({ sku:'', productId:'', quantity:'1', reason:'', restock: true });
  const [saving, setSaving] = useState(false);

  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const selectProduct = (productId) => {
    const p = (products||[]).find(p=>String(p.id)===productId);
    if (p) setForm(f=>({...f, productId, sku:p.sku}));
  };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/api/rma', { ...form, productId: form.productId ? parseInt(form.productId) : null, quantity: parseInt(form.quantity) });
      onSaved('RMA created successfully'); onClose();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  return (
    <Modal title="New Return / RMA" onClose={onClose}
      footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn btn-primary" form="add-rma-form" type="submit">{saving?'Saving…':'Create RMA'}</button></>}>
      <form id="add-rma-form" onSubmit={save}>
        <div className="form-group">
          <label>Product</label>
          <select value={form.productId} onChange={e=>selectProduct(e.target.value)}>
            <option value="">— Select product —</option>
            {(products||[]).map(p=><option key={p.id} value={p.id}>{p.sku} — {p.name}</option>)}
          </select>
        </div>
        <div className="form-row">
          <div className="form-group"><label>SKU *</label><input required value={form.sku} onChange={e=>set('sku',e.target.value)} /></div>
          <div className="form-group"><label>Quantity *</label><input type="number" required min="1" value={form.quantity} onChange={e=>set('quantity',e.target.value)} /></div>
        </div>
        <div className="form-group"><label>Reason</label><textarea value={form.reason} onChange={e=>set('reason',e.target.value)} /></div>
        <div className="form-group" style={{ display:'flex', alignItems:'center', gap:10 }}>
          <input type="checkbox" id="restock" style={{ width:'auto' }} checked={form.restock} onChange={e=>set('restock',e.target.checked)} />
          <label htmlFor="restock" style={{ marginBottom:0 }}>Restock to warehouse inventory when processed</label>
        </div>
      </form>
    </Modal>
  );
}
